import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchTaxFormsTypes = getApiActionTypes('DEVELOPMENT/FETCH_TAX_FORMS');
export const PULL_GENERATE_PDF_SUCCESS = 'DEVELOPMENT/PULL_GENERATE_PDF_SUCCESS';
export const SELECT_FORM_ID = 'DEVELOPMENT/SELECT_FORM_ID';
export const CHANGE_IS_ADDING_FORM = 'DEVELOPMENT/CHANGE_IS_ADDING_FORM';
export const addEditTaxFormTypes = getApiActionTypes('DEVELOPMENT/ADD_EDIT_TAX_FORM');
export const deleteFormTypes = getApiActionTypes('DEVELOPMENT/DELETE_FORM');
